import { MediaTypes } from '~/constants';
import { ServiceDefinition } from '~/constants/services/types';

export const getMixedMediaError = (service: ServiceDefinition): string => {
  let message = 'We can only attach one type of file at the same time: either ';
  message += service.maxAttachableImagesCount > 1 ? 'images' : 'an image';
  message += service.canHaveMediaAttachmentType(MediaTypes.GIF)
    ? ', or a gif,'
    : '';
  message += ' or a video.<br/>';
  message += 'Could you try with only one of those?';

  return message;
};
